'use strict'

/**
 * Validates the reCAPTCHA response token by sending it to the server for verification.
 *
 * @param {string} captchaValue - The reCAPTCHA response token provided by the client.
 * @param {string} clientIP - The IP address of the client making the request.
 * @returns {Promise<Object>} A promise that resolves to an object containing the validation result.
 * @property {boolean} success - Indicates whether the reCAPTCHA validation was successful.
 * @property {string} message - A message providing additional information about the validation result.
 *                              If successful, the message will be 'Success'. If unsuccessful, it will
 *                              contain error details.
 *
 * @example
 * const result = await validateRecaptcha('responseToken', '192.168.1.1');
 * if (result.success) {
 *     console.log('Captcha validated successfully');
 * } else {
 *     console.error('Captcha validation failed:', result.message);
 * }
 */
export const validateRecaptcha = async (captchaValue, clientIP) => {
    let result = {
        success: false,
        message: ''
    }

    try {
        const response = await fetch('/validate-recaptcha', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({token: captchaValue, clientIP: clientIP})
        })

        const data = await response.json()

        if (data.success) {
            result.success = true
            result.message = `Success`
        } else {
            result.success = false
            result.message = `Error verifying captcha: ${data['error-codes'].join(', ')}`
        }
    } catch (error) {
        result.success = false
        result.message = error.message
    }
    return result
}
